import { Stack } from "@mui/material";
import { useState, useEffect } from "react";
import { Header } from "../index";
import { EG_Logo } from "./EG_Logo";
import { LeftNavController } from "./LeftNavController";
import { LeftNavMenuItems } from "./LeftNavMenuItems";
import { globalTheme } from "../../styles";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticatedEmployee } from "../../hooks";
import { useTokenRefresh } from "../../apiHooks/useTokenRefresh";

export const LeftNav = () => {
  const refreshToken = useTokenRefresh();

  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticatedEmployee();

  !isAuthenticated && navigate("/login");

  const [isLeftNavExpanded, setIsLeftNavExpanded] = useState(getOnLoadLeftNavState());

  const handleLeftNavStateUpdate = () => {
    setIsLeftNavExpanded((prevIsLeftNavExpanded) => !prevIsLeftNavExpanded);
  };

  const updateStyles = () => {
    const marginLeftValue = isLeftNavExpanded ? "275px" : "85px";
    // Apply the style to the main element
    const mainElement = document.querySelector(".mainContentContainer") as HTMLElement;

    if (mainElement) {
      mainElement.style.marginLeft = marginLeftValue;
    }
  };

  const handleResize = () => {
    // Adjust styles based on screen width
    const screenWidth = window.innerWidth;
    const mainElement = document.querySelector(".mainContentContainer") as HTMLElement;

    if (mainElement && screenWidth < 1200) {
      setIsLeftNavExpanded(false);
      mainElement.style.marginLeft = "85px";
    } else {
      setIsLeftNavExpanded(true);
      // Update styles when screen size is 1200px or more
      updateStyles();
    }
  };

  useEffect(() => {
    localStorage.setItem("expandedLeftNav", JSON.stringify(isLeftNavExpanded));
    updateStyles();

    // Attach the event listener for window resize
    window.addEventListener("resize", handleResize);

    // Check and refresh token every minute if necessary
    const interval = setInterval(() => {
      refreshToken; // Check the token validity every second
    }, 1000);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(interval);
    };
  }, [isLeftNavExpanded, refreshToken]);

  const leftNavStyle = {
    height: "100vh",
    background: globalTheme.background,
    color: globalTheme.primaryColor,
    transition: "all .3s",
    width: isLeftNavExpanded ? "275px" : "80px",
    overflow: "scroll",
    scrollbarWidth: "none",
  };

  return (
    <Stack direction={"row"}>
      <Stack alignItems="center" justifyContent="space-between" sx={leftNavStyle}>
        <Stack spacing={6} alignItems="center">
          <EG_Logo isLeftNavExpanded={isLeftNavExpanded} />
          <LeftNavMenuItems isLeftNavExpanded={isLeftNavExpanded} />
        </Stack>
        <LeftNavController isLeftNavExpanded={isLeftNavExpanded} onLeftNavResize={handleLeftNavStateUpdate} />
      </Stack>
      <Header isLeftNavExpanded={isLeftNavExpanded} />
    </Stack>
  );
};

const getOnLoadLeftNavState = () => {
  const leftNavState = JSON.parse(localStorage.getItem("expandedLeftNav") || null);

  const setLeftNavState = () => {
    return window.innerWidth < 1200 ? false : true;
  };

  return leftNavState !== null ? leftNavState : setLeftNavState();
};
